import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { commonColors } from '@linqpal/common-frontend/src/theme'

interface ListPlaceholderProps {
  image: React.ReactElement
  heading: string
  subHeading: string
  style?: any
}

export const ListPlaceholder: React.FC<ListPlaceholderProps> = ({
  image,
  heading,
  subHeading,
  style,
}) => {
  return (
    <View style={composeStyle(styles.view, style)}>
      {image}
      <View style={styles.childView}>
        <Text style={styles.heading}>{heading}</Text>
        <Text style={styles.subheading}>{subHeading}</Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  childView: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
  },
  heading: {
    fontWeight: '600',
    fontSize: 18,
    lineHeight: 28,
  },
  subheading: {
    textAlign: 'center',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 21,
    maxWidth: 268,
    paddingTop: 14,
    color: commonColors.textLight,
  },
})
